import styled from "styled-components";
import useLanguage from "../../hooks/useLanguage";

const Select = styled.select`
  height: 38px;
  padding: 0 10px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  cursor: pointer;
`;

export function LanguageSwitcher({ id = "language-switcher" }) {
  const { language, languages, changeLanguage } = useLanguage();

  return (
    <Select
      id={id}
      value={language}
      onChange={(event) => changeLanguage(event.target.value)}
      aria-label="Язык сайта"
    >
      {languages.map(({ code, label }) => (
        <option key={code} value={code}>
          {label}
        </option>
      ))}
    </Select>
  );
}

export default LanguageSwitcher;
